import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

const getBanners = async () => {
  return privateRequest.get(`${ConfEnv.API_BANNERS.URL_BANNERS}`);
};

export default getBanners;
